import Sidebar from "../../components/Common/Sidebar";
import { Esquad } from "../../components/_pages/ESquad";

const ESQUADPAGE = () => {
  return (
    <>
      <Sidebar />
      <Esquad />
    </>
  );
};

export default ESQUADPAGE;
